import { Collapse } from 'antd';
import { useContext, useEffect, useState } from 'react';
import './RightKitchenEquipmentDesignMenu.scss';
import { Icon } from '../../../../components/icon/icon';
import { DesignerPageContext } from '../../DesignerPage';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import TabComponent from '../../../../components/common/TabComponent/TabComponent';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccessoryByType } from '../../../../store/actions/insideAccessory.action';
import { Spin } from 'antd/es';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import { InsideType } from '../../../../constants/enum';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import { convertForeignCurrency } from '../../../../utils/currency/currency.utils';

const { Panel } = Collapse;

const RightKitchenEquipmentDesignMenu = ({
  title,
  open,
  types,
  onClose,
  className,
}) => {
  const { currentCabinet, selectedModel, sceneManager, insideLoaderRef } =
    useContext(DesignerPageContext);

  const [tab, setTab] = useState();
  const [activeInsideUuid, setActiveInsideUuid] = useState();
  const [tempTypes, setTempTypes] = useState([]);
  const [check, setCheck] = useState(false);
  const dispatch = useDispatch();
  const { accessoriesByType } = useSelector(state => state.insideAccessory);

  const [tabItems, setTabItems] = useState(() =>
    types.map(item => ({
      key: item.gltfUuid,
      gltfUuid: item.gltfUuid,
      label: item.label,
      type: item.type,
      group: item.group,
    }))
  );

  const handleClick = async item => {
    const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
    const moduleEntries = Array.from(modules?.entries() ?? {});
    const module = moduleEntries.find(
      ([, value]) => value.group.uuid === selectedModel?.uuid
    );
    if (module && insideLoaderRef.current) {
      const [key, value] = module;
      const listInside = value.listInside;

      const originalModule = sceneManager.cabinetManager.getModuleByGltfUuid(
        selectedModel?.uuid
      );
      if (currentCabinet) {
        const currentInside = listInside.find(
          i => i.gltfUuid === activeInsideUuid
        );
        if (!currentInside && item.type === InsideType.ACCESSORY_SINK) return;
        const oldUuid = activeInsideUuid;
        const resultData = await insideLoaderRef?.current?.switchModelAccessory(
          item,
          originalModule,
          currentCabinet,
          currentInside
        );

        const newGltfUuid = resultData?.gltfUuid;
        if (newGltfUuid) {
          setActiveInsideUuid(newGltfUuid);
          setCheck(true);
        }

        await sceneManager.calculateTotalCost?.({});

        setTabItems(prev =>
          prev.map(t => {
            if (t.gltfUuid !== oldUuid) return t;
            return {
              ...t,
              key: newGltfUuid,
              gltfUuid: newGltfUuid,
            };
          })
        );

        setTempTypes(prev => {
          return prev.map(type => {
            if (type.gltfUuid === activeInsideUuid) {
              return {
                ...type, // Giữ LẠI tất cả fields gốc (key, gltfUuid, type, group, label)
                id: item.id, // Chỉ update id của accessory mới
                name: item.name, // Update tên nếu cần
                gltfUuid: newGltfUuid,
                icon: item.icon, // Update icon nếu cần
                price: item.price, // Update giá nếu cần
              };
            }
            return type; // Giữ nguyên các items khác
          });
        });
        setTimeout(async () => {
          await sceneManager.calculateTotalCost?.({});
        }, 0);
      }
    }
  };

  useEffect(() => {
    if (open) {
      if (types.length && !tab) {
        setTempTypes(types);
        setTab(types[0].gltfUuid); // tab = gltfUuid
        setActiveInsideUuid(types[0].gltfUuid);
        dispatch(
          fetchAccessoryByType({
            accessory_type: types[0].type,
            accessory_group: types[0].group,
          })
        );
      }
    } else {
      setTab();
      setActiveInsideUuid();
      setTempTypes([]);
    }
  }, [types, open]);

  useEffect(() => {
    if (!check) {
      setTabItems(
        types.map(item => ({
          key: item.gltfUuid,
          gltfUuid: item.gltfUuid,
          label: item.label,
          type: item.type,
          group: item.group,
        }))
      );
    }
  }, [types]);

  // useEffect(() => {
  //   if (open && tab) {
  //     dispatch(
  //       fetchAccessoryByType({
  //         accessory_type: tab,
  //         accessory_group: types.find((item) => item.key === tab)?.group,
  //       })
  //     );
  //   }
  // }, [tab]);

  // const tabItems = types.map(item => ({
  //   key: item.gltfUuid, // ✔ key UNIQUE
  //   gltfUuid: item.gltfUuid, // redundant nhưng rõ ràng
  //   label: item.label,
  //   type: item.type, // tuỳ bạn đang dùng field nào là type
  //   group: item.group,
  // }));

  return (
    <RightMenuDesign
      open={open}
      classNames={{
        root: 'top-84 ' + className,
        content: '!p-0 gap-0',
      }}
      header={
        <div className="flex self-stretch items-center justify-start gap-8">
          <ButtonIconGhostMedium
            icon={<Icon.ICArrowBack />}
            onClick={onClose}
          />
          <span className="text-title-large">{title}</span>
        </div>
      }
      content={
        <>
          {tabItems.length > 1 ? (
            <div
              className="right-cabinet-design-menu-header flex p-16 items-start gap-8 self-stretch bg-fills-white"
              style={{
                overflowX: 'auto',
                overflowY: 'visible',
                minHeight: 'fit-content',
              }}
            >
              <TabComponent
                items={tabItems}
                style={{ width: 'fit-content', gap: '0' }}
                defaultActiveKey={tab}
                onChange={value => {
                  setTab(value); // tab giờ lưu gltfUuid
                  setActiveInsideUuid(value); // vì value chính là gltfUuid

                  const selected = tabItems.find(item => item.key === value);
                  if (!selected) return;

                  dispatch(
                    fetchAccessoryByType({
                      accessory_type: selected.type, // dùng type thực tế ở đây
                      accessory_group: selected.group, // đúng group tương ứng
                    })
                  );
                }}
              />
            </div>
          ) : null}

          {accessoriesByType.isLoading && (
            <div className="flex p-24 items-center justify-center self-stretch grow">
              <Spin spinning />
            </div>
          )}
          <div
            className="grid grid-cols-2 p-8 self-stretch items-start gap-2 overflow-scroll"
            style={{ backgroundColor: '#F7F7F7' }}
          >
            {accessoriesByType?.data?.map(item => {
              const name = getValueFromString(item.name);
              const description = getValueFromString(item.description);

              return (
                <CardProduct
                  key={item.id}
                  md={item}
                  active={tempTypes.some(
                    type =>
                      type.gltfUuid === activeInsideUuid && type.id === item.id
                  )}
                  src={item.icon}
                  title={name}
                  description1={
                    item.width && item.depth && item.height ? (
                      <span className="text-body-small text-nowrap">
                        {`R${item.width ?? '--'} * S${item.depth ?? '--'} * C${
                          item.height ?? '--'
                        }`}
                      </span>
                    ) : null
                  }
                  description2={convertForeignCurrency(item.price)}
                  onClick={async () => await handleClick(item)}
                />
              );
            })}
            {/* </InfiniteScroll> */}
          </div>
        </>
      }
    />
  );
};

export default RightKitchenEquipmentDesignMenu;
